import { render, staticRenderFns } from "./platformRefundPanel.vue?vue&type=template&id=7906f804&scoped=true&"
import script from "./platformRefundPanel.vue?vue&type=script&lang=js&"
export * from "./platformRefundPanel.vue?vue&type=script&lang=js&"
import style0 from "./platformRefundPanel.vue?vue&type=style&index=0&id=7906f804&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7906f804",
  null
  
)

export default component.exports